import React from 'react';
import '../styles/Content.css';

function ContentSection({ sectionTitle, sectionDescription, gallery, items, sectionClass, showNumbers = true, spacer = false, titleTag = 'h3' }) {
  return (
	<>
	  {/* Spacer Div if needed */}
	  {spacer && <div className="content-spacer"></div>}

	  <section className={`content-container ${sectionClass}`}>
		{/* Section Title & Description */}
		{sectionTitle && (
			sectionClass === 'left-align-section' ? (
				<h3 className="content-title" style={{ textAlign: 'left', paddingBottom: '20px', paddingTop: 0 }}>
					{sectionTitle}
				</h3>
			) : (
				<h2 className="content-header">{sectionTitle}</h2>
			)
		)}
		{sectionDescription && <p className="content-description">{sectionDescription}</p>}

		{/* Content Grid */}
		<div className="content-section">
		  {items.map((item, index) => (
			<div key={index} className={`content-item ${item.imageSrc ? 'has-image' : ''} ${item.imagePosition === 'left' ? 'image-left' : ''} ${item.imagePosition === 'right' ? 'image-right' : ''} ${item.imagePosition === 'top' ? 'image-top' : ''} ${item.imagePosition === 'inside' ? 'image-inside' : ''} ${item.imagePosition === 'alternating' ? 'image-alternating' : ''}`}>

			{/* Image Gallery */}
			  {gallery && (
				<div className="content-gallery">
				  {gallery.map((image, imgIndex) => (
					<img key={imgIndex} src={image} alt={`Gallery ${imgIndex + 1}`} className="gallery-image" />
				  ))}
				</div>
			  )}

			  <div className="content-card">
				{/* Show number only if showNumbers is true */}
				{showNumbers && <h3 className="content-number">{String(index + 1).padStart(2, '0')}</h3>}

				{/* Alternating sections layout */}
				{item.imagePosition === 'alternating' && item.sections ? (
				  <>
					{item.title && (
					  <h3 className="content-title">{item.title}</h3>
					)}
					<div className="content-alternating-sections">
					  {item.sections.map((section, secIndex) => (
						<div key={secIndex} className={`content-alternating-row ${section.imagePosition === 'left' ? 'image-left' : 'image-right'}`}>
						  <div className="content-alternating-image">
							<img src={section.imageSrc} alt={section.subtitle || 'Feature'} />
						  </div>
						  <div className="content-alternating-text">
							<h4 className="content-subtitle">{section.subtitle}</h4>
							<p className="content-body">{section.body}</p>
						  </div>
						</div>
					  ))}
					</div>
				  </>
				) : (
				  <>
					<div className={`content-card-inner ${item.imagePosition === 'left' ? 'image-left' : ''} ${item.imagePosition === 'right' ? 'image-right' : ''}`}>
					  {/* Item Image inside card */}
					  {item.imageSrc && (item.imagePosition === 'left' || item.imagePosition === 'right') && (
						<div className="content-card-image">
						  <img src={item.imageSrc} alt={item.title || 'Feature'} />
						</div>
					  )}

					  <div className="content-card-text">
						{/* Content Titles - only render if title exists */}
						{item.title && (
							titleTag === 'h2' ? (
								<h2 className="content-title">{item.title}</h2>
							) : (
								<h3 className="content-title">{item.title}</h3>
							)
						)}

						{/* First Body Content with Subtitle */}
						{item.subtitle1 && <h4 className="content-subtitle">{item.subtitle1}</h4>}
						<div className="content-body">{item.body1}</div>

						{/* Second Body Content with Subtitle */}
						{item.subtitle2 && <h4 className="content-subtitle">{item.subtitle2}</h4>}
						{item.body2 && <div className="content-body">{item.body2}</div>}

						{/* Third Body Content with Subtitle */}
						{item.subtitle3 && <h4 className="content-subtitle">{item.subtitle3}</h4>}
						{item.body3 && <div className="content-body">{item.body3}</div>}
					  </div>
					</div>

					{/* Item Image at bottom for 'inside' position */}
					{item.imageSrc && item.imagePosition === 'inside' && (
					  <div className="content-card-image-bottom">
						<img src={item.imageSrc} alt={item.title || 'Feature'} />
					  </div>
					)}
				  </>
				)}
			  </div>
			</div>
		  ))}
		</div>
	  </section>
	</>
  );
}

export default ContentSection;
